import { ShieldCheck, Zap, BadgeDollarSign, Hammer, Home, Sparkles } from "lucide-react";
import { WHY_CHOOSE_US } from "@/data/content";

const ICONS = [ShieldCheck, Zap, BadgeDollarSign, Hammer, Home, Sparkles];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[#0E0E10] text-white py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-60 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-16">
          <div className="md:col-span-5">
            <div className="eyebrow">Why Choose Us</div>
            <h2 className="font-serif-display mt-4 text-4xl md:text-6xl leading-[1.05] tracking-tight">
              Built on <span className="italic text-[#C8A44D]">trust</span>, finished with pride.
            </h2>
          </div>
          <p className="md:col-span-7 md:self-end text-white/65 text-base md:text-lg font-light leading-relaxed max-w-2xl">
            Broady Home Services isn&apos;t another handyman. It&apos;s a standard. Every
            visit is on-time, every detail is intentional, and every home is
            treated like our own.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {WHY_CHOOSE_US.map((w, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={w.title}
                data-testid={`why-item-${i}`}
                className="group bg-[#0E0E10] p-9 md:p-11 transition-colors duration-500 hover:bg-[#161618]"
              >
                <Icon
                  size={26}
                  strokeWidth={1.25}
                  className="text-[#C8A44D] mb-7 transition-transform duration-500 group-hover:-translate-y-1"
                />
                <h3 className="font-serif-display text-2xl md:text-3xl tracking-tight">
                  {w.title}
                </h3>
                <p className="mt-3 text-white/60 font-light leading-relaxed text-sm md:text-base">
                  {w.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
